import apiClient from "../config/apiClient";

export const prescribeFill = async (data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.post(`/public/portal?url=requests/prescribe-fill`,
       data,
       {
        headers: {
        Authorization: "Bearer " + token,
      },
    });
};
